import React from 'react';
import { EditorState, Modifier, SelectionState } from 'draft-js';

export class PlaceHolderBlock extends React.Component {
	render() {
		const { entityData, store } = this.props.blockProps;
		const { text } = entityData;

		const clear = () => {
			const { getEditorState, setEditorState } = store;
			/** @type {EditorState} */
			const editorState = getEditorState();
			const selection = editorState.getSelection();
			let contentState = Modifier.setBlockType(
				editorState.getCurrentContent(),
				selection,
				'unstyled'
			);
			const blockKey = selection.getAnchorKey();
			const block = contentState.getBlockForKey(blockKey);
			const targetRange = new SelectionState({
				anchorKey: blockKey,
				anchorOffset: 0,
				focusKey: blockKey,
				focusOffset: block.getText().length,
			});
			contentState = Modifier.replaceText(contentState, targetRange, '');
			setEditorState(
				EditorState.forceSelection(
					EditorState.set(
						editorState,
						{
							currentContent: contentState,
						},
					),
					new SelectionState({
						anchorKey: blockKey,
						anchorOffset: 0,
						focusKey: blockKey,
						focusOffset: 0,
					})
				)
			);
		};

		return (
			<div className="placeholder-block" onClick={clear}>
				{text}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/placeholderPlugin/PlaceHolderBlock.jsx